module.exports = __webpack_public_path__ + "static/media/goals-and-targets-eps.b08fbbe9.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/goals-and-targets-eps.mp4
// module id = 558
// module chunks = 0